module.exports = {
  search: 'ค้นหา',
  isCustomer: 'ลูกค้า',
  isBookingAgent: 'ตัวแทนจัดเรือ',
  isOverseaAgent: 'ตัวแทนท่าปลายทาง',
  isDesignationAgent: 'ตัวแทนจัดส่งสินค้า',
  isLocalAgent: 'ตัวแทนท้องถิ่น',
  isSeaCmp: 'บริษัท เรือ',
  isAirCmp: 'สายการบิน',
  isCustomsBroker: 'บริษัทศุลกากร',
  isTruckCmp: 'บริษัทขนส่งทางรถบรรทุก',
  isWarehouse: 'คลังสินค้า',
  isGlobal: 'กลุ่มบริษัท',
  isShipper: 'ผู้ส่งสินค้า',
  isConsignee: 'ผู้รับสินค้า',
  isNotify: 'ผู้แจ้ง',
  isActive: 'มีผลหรือไม่',
  isShowHq: 'แสดงลูกค้า HQ หรือไม่',
  btMerge: 'รวม',
  btnRemove: 'ลบ',
  btnAdd: 'เพิ่ม',
  btnRefresh: 'รีเฟรช',
  btnLookUp: 'ดู',
  totalCount: 'จำนวนรายการทั้งหมด',
  btAudit: 'ตรวจสอบ',
  btCacelAudit: 'ยกเลิกการตรวจสอบ',
  approvedState: 'สถานะการตรวจสอบ',
  approvedBy: 'ผู้ตรวจสอบ',
  dateApproved: 'วันที่ตรวจสอบ',
  dateCreated: 'วันที่สร้าง',
  to: 'ถึง',
  dateModified: 'วันที่แก้ไข',
  parter: 'พันธมิตร',
  customerType: 'ประเภทลูกค้า',
  sales: 'การขาย',
  customerLevel: 'ระดับลูกค้า',
  whetherReview: 'ตรวจสอบหรือไม่',
  whetherEffective: 'มีผลหรือไม่',
  amount: 'จำนวนรายการ',
  query: 'สอบถาม',
  add: 'เพิ่มใหม่',
  delete: 'ลบ',
  view: 'ดู',
  review: 'ตรวจสอบ',
  batchPrint: 'พิมพ์เป็นชุด',
  B2BRegistrationInvitation: 'เชิญสมัคร B2B',
  freightAuthorization: 'อนุญาตอัตราค่าขนส่ง',
  combine: 'รวม',
  batchEditInvoiceHeader: 'เปลี่ยนหัวใบแจ้งหนี้เป็นชุด',
  batchEditSalers: 'เปลี่ยนการขายเป็นชุด',
  batchEditServer: 'เปลี่ยนพนักงานบริการเป็นชุด',
  templateDownload: 'ดาวน์โหลดเทมเพลต',
  import: 'นำเข้า',
  exportAgentList: 'ส่งออกรายชื่อตัวแทน',
  downloadImportTemplate: 'ดาวน์โหลดเทมเพลตนําเข้า',
  downloadImportResults: 'ดาวน์โหลดผลการนำเข้า',
  number: 'เลขที่',
  abbreviation: 'ชื่อย่อ',
  code: 'รหัส',
  chineseName: 'ชื่อภาษาจีน',
  englishName: 'ชื่อภาษาอังกฤษ',
  branchCompany: 'สาขา',
  creator: 'ผู้สร้าง',
  creationDate: 'วันที่สร้าง',
  modifier: 'ผู้แก้ไข',
  modificationDate: 'วันที่แก้ไข',
  ecommerceCustomer: 'ลูกค้าอีคอมเมิร์ซ',
  day30day: '30 วัน (ตั๋ว)',
  day60day: '60 วัน (ตั๋ว)',
  day90day: '90 วัน (ตั๋ว)',
  gt90day: 'มากกว่า 90 วัน (ตั๋ว)',
  all: 'ทั้งหมด',
  yes: 'ใช่',
  no: 'ไม่',
  return: 'กลับ',
  edit: 'แก้ไข',
  save: 'บันทึก',
  cancel: 'ยกเลิก',
  basicInformation: 'ข้อมูลพื้นฐาน',
  contacts: 'ผู้ติดต่อ',
  customer: 'ลูกค้า',
  creditAccount: 'บัญชีเครดิต',
  contractNumber: 'เลขที่สัญญา',
  documentation: 'เอกสาร',
  doorInformation: 'ข้อมูลจุดรับส่ง',
  specialRequirements: 'ข้อกำหนดพิเศษ',
  invoicingRequirements: 'ข้อกำหนดการออกใบแจ้งหนี้',
  destinationPortHandlingAgent: 'ตัวแทนดำเนินการที่ท่าเรือปลายทาง',
  destinationNominatedAgent: 'ตัวแทนจัดส่งสินค้าที่ท่าเรือปลายทาง',
  portLocation: 'ท่าเรือที่ตั้ง',
  spaceCarrier: 'ผู้ให้บริการพื้นที่บรรทุก',
  spaceAgent: 'ตัวแทนพื้นที่บรรทุก',
  warehouseInformation: 'ข้อมูลคลังสินค้า',
  EDIConfiguration: 'การตั้งค่า EDI',
  AddressInformation: 'ข้อมูลที่อยู่',
  BranchAuthorization: 'การอนุญาตสาขา',
  activity: 'ใช้งานอยู่',
  crossTenantAuthorize: 'มอบหมายงานข้าม Tenant',
  crossTenantAuthorizeAgreement: 'ข้อตกลงมอบหมายงานข้าม Tenant',
  agree: 'ยอมรับ',
  theOtherPlatformID: 'ID แพลตฟอร์มของอีกฝ่าย',
  seaCmpAgent: 'ตัวแทนเรือ',
  destinationAgent: 'ตัวแทนท่าเรือปลายทาง',
  nominatedAgent: 'ตัวแทนจัดส่งสินค้าที่กำหนด',
  localAgent: 'ตัวแทนท้องถิ่น',
  settlementAgent: 'ตัวแทนชำระเงิน',
  shippingCompany: 'บริษัทเรือ',
  airlineCompany: 'สายการบิน',
  customsBroker: 'บริษัทศุลกากร',
  warehouse: 'คลังสินค้า',
  truckCompany: 'บริษัทขนส่งทางรถบรรทุก',
  shipper: 'ผู้ส่งสินค้า',
  consignee: 'ผู้รับสินค้า',
  notify: 'ผู้แจ้งเตือน',
  chkMustInputScn: 'จำเป็นต้องกรอกข้อมูลผู้ส่ง-ผู้รับ-ผู้แจ้งเตือนหรือไม่',
  others: 'อื่นๆ',
  relatedBusinessType: 'ประเภทธุรกิจที่เกี่ยวข้อง',
  oceanExport: 'ส่งออกทางทะเล',
  oceanImport: 'นำเข้าทางทะเล',
  airExport: 'ส่งออกทางอากาศ',
  airImport: 'นำเข้าทางอากาศ',
  relatedBranch: 'สาขาที่เกี่ยวข้อง',
  paymentType: 'ประเภทการชำระเงิน',
  whetherCollection: 'เป็นการเรียกเก็บเงินหรือไม่',
  usingSettlementAgent: 'ใช้ตัวแทนชำระเงิน',
  country: 'ประเทศ (ภูมิภาค)',
  province: 'จังหวัด',
  city: 'เมือง',
  district: 'เขต',
  address: 'ที่อยู่',
  postCode: 'รหัสไปรษณีย์',
  telephone: 'โทรศัพท์',
  fax: 'แฟกซ์',
  website: 'เว็บไซต์',
  rmbAccount: 'บัญชีเงินหยวน',
  usdAccount: 'บัญชีเงินดอลลาร์',
  taxRate: 'อัตราภาษี',
  additionalDescription: 'คำอธิบายเพิ่มเติม',
  tel: 'โทรศัพท์',
  sapCustomerCode: 'รหัสลูกค้า SAP',
  sapSupplierCode: 'รหัสผู้จำหน่าย SAP',
  isSignContract: 'มีการเซ็นสัญญาหรือไม่',
  ContractStatus: 'สถานะการเซ็นสัญญา',
  ClientContractStatus: 'สถานะการเซ็นสัญญาลูกค้า',
  SupplierContractStatus: 'สถานะการเซ็นสัญญาผู้จำหน่าย',
  OverseasAgencyContractStatus: 'สถานะการเซ็นสัญญาตัวแทนต่างประเทศ',
  OtherContractStatus: 'สถานะการเซ็นสัญญาอื่นๆ',
  ContractApproxStatus: 'สถานะเลขที่สัญญา',
  name: 'ผู้ติดต่อ',
  function: 'หน้าที่',
  isDefault: 'เป็นค่าเริ่มต้นหรือไม่',
  Email: 'ที่อยู่อีเมล',
  mobile: 'โทรศัพท์มือถือ',
  pushNode: 'ผลักดันโหนด',
  pushMode: 'วิธีการผลักดัน',
  remark: 'หมายเหตุ',
  airline: 'เส้นทางเดินเรือ',
  departmentBelonging: 'หน่วยงานที่เกี่ยวข้อง',
  peers: 'เพื่อน',
  isPeers: 'ไม่ว่าจะเป็นเพื่อน',
  introductionDate: 'วันที่เปิดใช้งาน i-trace',
  customerSpace1: 'ประเภทของแพ็คเกจ',
  customerSpace2: 'สินค้าระบุ',
  customerSpace3: 'แพคเกจด้วยตนเอง',
  portOfDestination: 'วัตถุประสงค์ของการทำธุรกรรมทางการเงินอื่น ๆ',
  theCorrespondingServicePartners: 'พนักงานบริการที่สอดคล้องกับคู่ค้า',
  theCorrespondingServiceOverseaAgent: 'ฝ่ายบริการลูกค้าต่างประเทศที่สอดคล้องกับตัวแทนท่าเรือปลายทาง',
  positionType: 'ประเภทตำแหน่งงาน',
  businessType: 'ประเภทธุรกิจ',
  user: 'ผู้ใช้',
  creditControlSettings: 'การตั้งค่าควบคุมเครดิต',
  defaultCreditInfoSettings: 'การบำรุงรักษาจดหมายปริยาย',
  defaultCreditInfoNote: 'หมายเหตุ: เมื่อมีการบำรุงรักษา Credit เริ่มต้นเนื้อหา Credit ที่ได้รับการบำรุงรักษาในปัจจุบันจะถูกควบคุมโดยค่าเริ่มต้นเมื่อพันธมิตรรายใหม่ในระบบ!',
  dateType: 'ประเภทวันที่',
  settlementMethod: 'วิธีการชำระเงิน',
  monthlySettlement: 'ชำระเงินรายเดือน',
  blacklist: 'บัญชีดำ',
  accountPeriod: 'ระยะเวลาบัญชี',
  limit: 'วงเงิน',
  settlementType: 'ประเภทการชำระเงิน',
  settlementByBill: 'ชำระด้วยตั๋ว',
  settlementNotByBill: 'ชำระแบบไม่ใช้ตั๋ว',
  revenueAndExpenditureType: 'ประเภทรายรับรายจ่าย',
  collections: 'รับเงิน',
  payment: 'จ่ายเงิน',
  depositAmount: 'จำนวนเงินมัดจำ',
  revenueAndExpenditureDate: 'วันที่รับจ่าย',
  revenueAndExpenditureMethod: 'วิธีการรับจ่าย',
  cash: 'เงินสด',
  depositCurrency: 'สกุลเงินมัดจำ',
  day: 'วัน',
  week: 'สัปดาห์',
  month: 'เดือน',
  space1: 'วันที่ธุรกิจ',
  space2: 'วันที่ใบแจ้งหนี้',
  space3: 'คำนวณรายสัปดาห์',
  space4: 'เดือนวันที่ระบุรายเดือน',
  space5: 'ชำระเงินครึ่งเดือน',
  space6: 'เช็ค',
  space7: 'โอนเงิน',
  space8: 'ตั๋วเงิน',
  space9: 'รับจ่ายแทน',
  space10: 'การให้สินเชื่อของธนาคาร',
  effectiveDate: 'วันที่มีผล',
  expiryDate: 'วันที่หมดอายุ',
  fileNumber: 'เลขที่เอกสาร',
  remarks: 'หมายเหตุ',
  documentSize: 'จำนวนไฟล์แนบ',
  attachment: 'ไฟล์แนบ',
  uploadFile: 'อัปโหลดไฟล์',
  upload: 'อัปโหลด',
  download: 'ดาวน์โหลด',
  fileName: 'ชื่อไฟล์',
  fileType: 'ประเภทไฟล์',
  fileFormat: 'รูปแบบไฟล์',
  fileSize: 'ขนาดไฟล์',
  viewFile: 'ดูไฟล์',
  whetherUploadContractAttachment: 'ต้องใช้ password หรือไม่',
  doorName: 'ชื่อจุดรับส่ง',
  contact: 'ผู้ติดต่อ',
  doorAddress: 'ที่อยู่จุดรับส่ง',
  canOverPrice: 'สามารถออกใบแจ้งหนี้สูงได้หรือไม่',
  invoicingMethod: 'วิธีการออกใบแจ้งหนี้',
  invoicingPerBill: 'ออกใบแจ้งหนี้แบบรายใบ',
  invoicingPerMonth: 'ออกใบแจ้งหนี้แบบรายเดือน',
  invoicingNote: 'หมายเหตุการออกใบแจ้งหนี้',
  invoiceHeader: 'ชื่อในใบแจ้งหนี้',
  registrationNumber: 'เลขประจำตัวผู้เสียภาษี',
  invoiceAddress: 'ที่อยู่ใบแจ้งหนี้',
  bankOfInvoiceHeader: 'ธนาคารในใบแจ้งหนี้',
  operation: 'ดำเนินการ',
  bankMaintenance: 'การบำรุงรักษาธนาคาร',
  confirm: 'ยืนยัน',
  currency: 'สกุลเงิน',
  bankName: 'ชื่อธนาคาร',
  bankAccount: 'เลขที่บัญชีธนาคาร',
  swiftCode: 'รหัส SWIFT',
  paymentLine: 'รหัสสาขา',
  forecastReceivingEmail: 'อีเมลรับการแจ้งเตือนล่วงหน้า',
  oceanBillOfLadingAddress: 'ที่อยู่ใบตราส่งสินค้าทางเรือ',
  airBillOfLadingAddress: 'ที่อยู่ใบตราส่งสินค้าทางอากาศ',
  agentLevel: 'ระดับตัวแทน',
  networkManager: 'ผู้รับผิดชอบเครือข่าย',
  billingAddress: 'ที่อยู่ใบแจ้งค่าใช้จ่าย',
  network: 'เครือข่าย',
  portName: 'ชื่อท่าเรือ',
  carrier: 'ผู้ขนส่ง',
  carrierType: 'ประเภทผู้ขนส่ง',
  bookingMethod: 'วิธีการจองพื้นที่',
  choose: '-กรุณาเลือก-',
  bookingAgent: 'ตัวแทนจองพื้นที่',
  ediSenderCode: 'รหัสผู้ส่ง EDI',
  ediReceiverCode: 'รหัสผู้รับ EDI',
  bookingPartyCode: 'รหัสผู้จองตู้',
  loadFailed: 'โหลดล้มเหลว',
  deleteing: 'กำลังลบ....',
  deleted: 'ลบแล้ว',
  occurredError: 'เกิดข้อผิดพลาด',
  deleteConfirmTitle: 'ยืนยันการลบ',
  deleteConfirmMessage: 'แน่ใจหรือไม่ที่จะลบข้อมูลนี้',
  formatInformation: 'ข้อมูลที่จัดรูปแบบ',
  notFormatInformation: 'ข้อมูลที่ไม่ได้จัดรูปแบบ',
  formatSynchronize: 'ซิงค์ข้อมูลที่จัดรูปแบบไปยังข้อมูลที่ไม่ได้จัดรูปแบบ',
  codeAbbreviation: 'อักษรย่อรหัส',
  enterpriseCode: 'รหัสบริษัท',
  partnerName: 'ชื่อ',
  detailAddress: 'ที่อยู่โดยละเอียด',
  phone: 'หมายเลขโทรศัพท์',
  email: 'ที่อยู่อีเมล',
  relexNumber: 'หมายเลขโทรเลข',
  cityName: 'ชื่อเมือง',
  provinceCode: 'รหัสจังหวัด',
  provinceName: 'ชื่อจังหวัด',
  postalCode: 'รหัสไปรษณีย์',
  countryCode: 'รหัสประเทศ',
  aeoEnterpriseCode: 'รหัสบริษัท AEO',
  specificContactName: 'ชื่อผู้ติดต่อโดยเฉพาะ',
  specificContactPhone: 'หมายเลขโทรศัพท์ผู้ติดต่อโดยเฉพาะ',
  specificContactAddress: 'ที่อยู่อีเมลผู้ติดต่อโดยเฉพาะ',
  specificContactRelexNumber: 'หมายเลขโทรเลขผู้ติดต่อโดยเฉพาะ',
  WarehouseType: 'ประเภทคลังสินค้า',
  WarehouseName: 'ชื่อคลังสินค้า',
  WarehouseAddress: 'ที่อยู่คลังสินค้า',
  WarehouseMap: 'แผนที่คลังสินค้า',
  PleaseSelect: 'กรุณาเลือก',
  Number: 'จำนวนตั๋ว',
  GreaterThan: 'มากกว่า',
  LessThan: 'น้อยกว่า',
  EqualTo: 'เท่ากับ',
  WhetherToPushSOPStatus: 'จะส่งสถานะ SOP หรือไม่',
  Push: 'ส่ง',
  NoPushing: 'ไม่ส่ง',
  portAgent: 'ตัวแทนท่าเรือ',
  forwardingAgent: 'ตัวแทนจัดส่ง',
  loadingPlaceCompany: 'บริษัทสถานที่บรรทุก',
  signBillPlaceCompany: 'บริษัทสถานที่เซ็นสัญญา',
  dischargePortCompany: 'บริษัทท่าขนถ่าย',
  destinationPortCompany: 'บริษัทท่าปลายทาง',
  ParentCompany: 'บริษัทแม่',
  SelectFile: 'เลือกไฟล์',
  DeleteFile: 'ลบไฟล์',
  Confirm: 'ตกลง',
  Cancel: 'ยกเลิก',
  FileName: 'ชื่อไฟล์',
  FileType: 'ประเภทไฟล์',
  FileSize: 'ขนาดไฟล์',
  Uploader: 'ผู้อัปโหลด',
  UploadTime: 'เวลาอัปโหลด',
  UploadProgress: 'ความคืบหน้าการอัปโหลด',
  DocumentType: 'หมวดหมู่เอกสาร',
  UnselectedContact: 'ยังไม่ได้เลือกผู้ติดต่อ',
  PartnerNotSaved: 'คู่ค้ายังไม่ได้บันทึก',
  UpdateMaterial: 'อัปโหลดข้อมูล',
  DataNotSelected: 'ยังไม่ได้เลือกข้อมูล',
  RailwayExport: 'ส่งออกทางรถไฟ',
  RefuseRemark: 'เหตุผลในการปฏิเสธ',
  Refuser: 'ผู้ปฏิเสธ',
  RefuseDate: 'วันที่ปฏิเสธ',
  REMARKS: 'คำอธิบายเพิ่มเติม',
  InternalRemark: 'หมายเหตุภายใน',
  supplyChainLines: 'เส้นทางซัพพลายเชน',
  Middleman: 'ตัวแทนจำหน่าย',
  Factory: 'โรงงาน',
  CompanyName: 'ชื่อบริษัท',
  Company: 'บริษัท',
  contacts_name: 'ผู้ติดต่อ',
  contacts_function: 'หน้าที่',
  contacts_telephone: 'โทรศัพท์',
  contacts_email: 'ที่อยู่อีเมล',
  contacts_mobile: 'มือถือ',
  contacts_remark: 'หมายเหตุ',
  credit_creditControlSettings: 'การตั้งค่าการควบคุมเครดิต',
  credit_dateType: 'ประเภทวันที่',
  credit_creditControlSettings_date: 'ประเภทวันที่การตั้งค่าการควบคุมเครดิต',
  credit_creditControl_date: 'ประเภทวันที่ควบคุมเครดิต',
  credit_settlementMethod: 'วิธีการชำระเงิน',
  credit_monthlySettlement: 'ชำระเงินรายเดือน',
  credit_blacklist: 'บัญชีดำ',
  credit_accountPeriod: 'ระยะเวลาบัญชี',
  credit_limit: 'วงเงิน',
  credit_settlementType: 'ประเภทการชำระเงิน',
  credit_settlementByBill: 'ชำระด้วยตั๋ว',
  credit_settlementNotByBill: 'ไม่ชำระด้วยตั๋ว',
  credit_revenueAndExpenditureType: 'ประเภทรายรับรายจ่าย',
  credit_collections: 'รับเงิน',
  credit_payment: 'จ่ายเงิน',
  credit_depositAmount: 'จำนวนเงินมัดจำ',
  credit_revenueAndExpenditureDate: 'วันที่รับ/จ่ายเงิน',
  credit_revenueAndExpenditureMethod: 'วิธีการรับ/จ่ายเงิน',
  credit_cash: 'เงินสด',
  credit_depositCurrency: 'สกุลเงินมัดจำ',
  credit_additionalDescription: 'คำอธิบายเพิ่มเติม',
  credit_day: 'วัน',
  credit_week: 'สัปดาห์',
  credit_month: 'เดือน',
  credit_space1: 'วันที่ทำธุรกิจ',
  credit_space2: 'วันที่ออกใบแจ้งหนี้',
  credit_space3: 'คำนวณเป็นรายสัปดาห์',
  credit_space4: 'วันที่กำหนดของแต่ละเดือน',
  credit_space5: 'ปิดบัญชีครึ่งเดือน',
  credit_space6: 'เช็ค',
  credit_space7: 'โอนเงิน',
  credit_space8: 'ตั๋วเงิน',
  credit_space9: 'รับและจ่ายแทน',
  credit_space10: 'สินเชื่อธนาคาร',
  credit_wtCreateCompany: 'เพิ่มพันธมิตรที่ได้รับการรับรองจากแพลตฟอร์มด้วยคลิกเดียว',
  partnerReview: 'การตรวจสอบพันธมิตร',
  partnerReviewed: 'พันธมิตรผ่านการตรวจสอบแล้ว',
  fillRejectReason: 'กรุณากรอกเหตุผลในการปฏิเสธ',
  auditRejected: 'การตรวจสอบถูกปฏิเสธ',
  changeServicePersonnel: 'เปลี่ยนผู้ให้บริการ',
  userName: 'ชื่อผู้ใช้',
  batchChangeSales: 'เปลี่ยนผลการขายเป็นชุด',
  positionTypeNotSelected: 'ยังไม่ได้เลือกประเภทตำแหน่งงาน',
  multipleSameBusinessPosition: 'มีบันทึกตำแหน่งงานธุรกิจที่ซ้ำกันหลายรายการ',
  defaultValueNotEmpty: 'ค่าเริ่มต้นไม่สามารถเว้นว่างได้!',
  setInitialPassword: 'ตั้งค่ารหัสผ่านเริ่มต้น',
  openB2BSettings: 'เปิดการตั้งค่า B2B',
  selectBookingAgent: 'กรุณาเลือกตัวแทนจัดจำหน่ายการจองที่เกี่ยวข้อง!',
  batchSelectBookingAgent: 'กรุณาเลือกตัวแทนจัดจำหน่ายการจองที่เกี่ยวข้องแบบกลุ่ม!',
  modificationOfBookingAgents: 'การปรับเปลี่ยนตัวแทนจัดจำหน่ายการจองแบบกลุ่ม',
  openB2BAccount: 'เปิดใช้งานบัญชี B2B',
  resetPassword: 'รีเซ็ตรหัสผ่าน',
  b2bUsers: 'ผู้ใช้ B2B',
  selectNotOpenedB2BAccount: 'กรุณาเลือกผู้ติดต่อที่ยังไม่ได้เปิดใช้งานบัญชี B2B',
  emailAddressIsIllegal: 'ที่อยู่อีเมลไม่ถูกต้อง!',
  selectAnApprovedPartner: 'กรุณาเลือกพันธมิตรที่ผ่านการตรวจสอบแล้ว',
  inputAPassword: 'กรุณากรอกรหัสผ่าน!',
  accountOpenedSuccessfully: 'เปิดใช้งานบัญชีสำเร็จ!',
  selectAContact: 'กรุณาเลือกผู้ติดต่อ',
  oneContactPasswordCanResetATime: 'สามารถรีเซ็ตรหัสผ่านผู้ติดต่อได้ครั้งละหนึ่งคนเท่านั้น',
  notOpenedB2BAccount: 'ผู้ติดต่อรายนี้ยังไม่ได้เปิดใช้งานบัญชี B2B',
  confirmToReset: 'ยืนยันการรีเซ็ต',
  yourLoginPassword: 'รหัสผ่านการเข้าสู่ระบบหรือไม่?',
  openResetPasswordLink: 'รีเซ็ตสำเร็จ กรุณาเปิดลิงก์รีเซ็ตรหัสผ่านในอีเมลเพื่อดำเนินการ',
  batchModifyServicePersonnel: 'แก้ไขผู้ให้บริการเป็นชุด',
  exportModificationResults: 'ส่งออกผลการแก้ไข',
  partnerAbbreviation: 'ชื่อย่อพันธมิตร',
  chineseNameOfPartner: 'ชื่อภาษาจีนของพันธมิตร',
  servicePersonal: 'ผู้ให้บริการ',
  isItSuccessful: 'สำเร็จหรือไม่',
  enterUserInformation: 'กรุณากรอกข้อมูลผู้ใช้',
  selectAUserToModify: 'กรุณาเลือกผู้ใช้ที่จะแก้ไข',
  modifyInvoicingHeader: 'แก้ไขชื่อในใบแจ้งหนี้',
  batchModifyInvoicingHeader: 'แก้ไขชื่อในใบแจ้งหนี้เป็นชุด',
  enterBillingHeaderInformation: 'กรุณากรอกข้อมูลชื่อในใบแจ้งหนี้',
  batchChangeSalesperson: 'เปลี่ยนพนักงานขายเป็นชุด',
  modifySalesperson: 'แก้ไขพนักงานขาย',
  batchModifySalesperson: 'แก้ไขพนักงานขายเป็นชุด',
  salesman: 'พนักงานขาย',
  selectRecordToExport: 'กรุณาเลือกบันทึกที่ต้องการส่งออก!',
  mergedPartners: 'พันธมิตรที่ถูกควบรวม',
  notPermissionEditOverseasAgent: 'คุณไม่มีสิทธิ์แก้ไขตัวแทนต่างประเทศ!',
  notPermissionEditCarrier: 'คุณไม่มีสิทธิ์แก้ไขผู้ขนส่ง!',
  companyIsSettlementAgentFollowingPartners: 'บริษัทนี้ปัจจุบันเป็นตัวแทนชำระเงินของพันธมิตรดังต่อไปนี้',
  confirmDisassociateAndSaveModification: 'ยืนยันที่จะยกเลิกความสัมพันธ์และบันทึกการแก้ไขหรือไม่',
  affiliatedBranch: 'สาขาที่เกี่ยวข้อง',
  contractAffiliatedBranch: 'สาขาที่เกี่ยวข้องกับสัญญา',
  alreadyAPartner: 'เป็นพันธมิตรแล้วหรือไม่',
  selectAPartner: 'กรุณาเลือกพันธมิตร!',
  applicationSentSuccessfully: 'ส่งคำขอสำเร็จแล้ว!',
  addPlatformCertificationPartners: 'เพิ่มพันธมิตรที่ได้รับการรับรองจากแพลตฟอร์ม เพื่อทำงานร่วมกับ "Woxing Home" ในการสร้างระบบนิเวศโลจิสติกส์',
  tariffLevelAuthorization: 'การอนุญาตระดับอัตราค่าขนส่ง',
  fullContainerFreightRate: 'อัตราค่าขนส่งแบบเต็มตู้',
  lclFreightRate: 'อัตราค่าขนส่งแบบรวมตู้',
  airFreightRate: 'อัตราค่าขนส่งทางอากาศ',
  fbaRate: 'ราคาเสนอ FBA',
  mergePartners: 'รวมพันธมิตร',
  updateSupplierData: 'อัปเดตข้อมูลลูกค้า/ผู้ขาย',
  maintainInformation: 'บำรุงรักษาการควบคุมเครดิตเป็นชุด',
  batchBlacklistSetting: 'ตั้งค่าบัญชีดำเป็นชุด',
  maintainDefaultCreditInfo: 'การควบคุมเครดิตเริ่มต้น',
  freightFateLevelIsAuthorized: 'อนุญาตระดับอัตราค่าขนส่งให้กลุ่มลูกค้า ไม่ใช่รายบุคคล',
  servicePersonnelSettingNotEnabled: 'ไม่ได้เปิดใช้งานการตั้งค่าพนักงานบริการสำหรับพันธมิตร',
  deletedWithAdministratorPermission: 'ต้องมีสิทธิ์ผู้ดูแลระบบจึงจะสามารถลบได้!',
  partnerNotSelected: 'ยังไม่ได้เลือกพันธมิตร.',
  partnerBeenUsedByBusiness: 'พันธมิตรถูกใช้งานโดยธุรกิจแล้ว.',
  mergedPartnerBeenAssociatedWithCRM: 'พันธมิตรที่ถูกควบรวมได้เชื่อมโยงกับ CRM แล้ว',
  mergedPartnerBeenAssociatedWithCRM1: 'พันธมิตรที่ถูกควบรวมได้เชื่อมโยงกับ CRM แล้ว ต้องการ{0} หรือไม่ หลังจากยกเลิกความสัมพันธ์แล้วสามารถดูพันธมิตรได้ที่เมนู "ถังขยะลูกค้า"',
  mergedPartnerBeenAssociatedWithCRM2: 'บังคับยกเลิกความสัมพันธ์',
  removeAssociationWithPartner: 'กรุณาไปที่ [การขาย-ลูกค้ากลุ่มนี้] / [การขาย-ทะเลลูกค้า] เพื่อลบความสัมพันธ์กับพันธมิตร',
  partnersWithCustomerAttributeCanBeSelected: 'สามารถเลือกพันธมิตรที่มีคุณสมบัติเป็นลูกค้าเท่านั้น',
  partnersWithOverseaAgentAttributeCanBeSelected: 'สามารถเลือกได้เฉพาะพาร์ทเนอร์ที่มีคุณสมบัติตัวแทนในต่างประเทศ.',
  authorizationSucceeded: 'อนุญาตสำเร็จ',
  groupCompaniesCannotBeMerged: 'ไม่สามารถรวมกลุ่มบริษัท!',
  chooseADifferentPartner: 'กรุณาเลือกพันธมิตรที่แตกต่างกัน!',
  noAuthorityToAuditCustomerRolePartners: 'คุณไม่มีสิทธิ์ตรวจสอบพันธมิตรในบทบาทลูกค้าจากข้อมูลที่เลือก!!!',
  noAuthorityToAuditSupplierRolePartners: 'คุณไม่มีสิทธิ์ตรวจสอบพันธมิตรในบทบาทผู้ขายจากข้อมูลที่เลือก!!!',
  vouchersBeenGeneratedContinue: 'เคยสร้างเอกสารแล้ว ต้องการรวมต่อหรือไม่?',
  mergeSuccessful: 'รวมสำเร็จ',
  uploadXLSFormatFile: 'กรุณาอัปโหลดไฟล์รูปแบบ xls/xlsx!',
  updateSucceeded: 'อัปเดตสำเร็จ!',
  failedUpdateSupplierData: 'อัปเดตข้อมูลลูกค้า/ผู้ขายล้มเหลว!',
  industrialAndCommercialInformationQuery: 'ค้นหาข้อมูลธุรกิจ',
  fleetCode: 'รหัสกองยานพาหนะ',
  platformSupplier: 'ผู้ขายบนแพลตฟอร์ม',
  ouJian: 'โอเจี้ยน',
  supplierPrincipal: 'ผู้รับผิดชอบผู้ขาย',
  crossTenantEntrustedBookingGeneralProtocol: 'ข้อตกลงทั่วไปสำหรับการจองพื้นที่ขนส่งข้าม Tenant บนแพลตฟอร์ม CARGOWARE',
  traders: 'ผู้ค้า',
  shortNameCannotBeEmpty: 'ชื่อย่อไม่สามารถเว้นว่างได้',
  oneBusinessTypeForCustomer: 'ต้องเลือกประเภทธุรกิจของลูกค้าอย่างน้อยหนึ่งรายการ',
  customerAddressNotEmpty: 'ที่อยู่ของลูกค้าไม่สามารถเว้นว่างได้',
  partnerRoleMustBeSelected: 'ต้องเลือกบทบาทของพันธมิตรอย่างน้อยหนึ่งรายการ',
  customerBusinessTypeMustBeSelected: 'ต้องเลือกประเภทธุรกิจของลูกค้าหนึ่งรายการ',
  usedByVoucherCannotModified: 'ถูกใช้โดยเอกสารแล้ว ไม่สามารถแก้ไขได้',
  usedByVoucherAreYouSureModified: 'พันธมิตรนี้ได้สร้างเอกสารแล้ว ยืนยันที่จะแก้ไขหรือไม่?',
  duplicatePartnerCodeAlreadyExists: 'รหัสพันธมิตรซ้ำกัน มีอยู่แล้ว โปรดตรวจสอบรหัสพันธมิตร!',
  partnerSameNameAlreadyExists: 'มีพันธมิตรชื่อซ้ำกันอยู่แล้ว โปรดตรวจสอบชื่อจีนหรือชื่ออังกฤษ',
  online: 'ออนไลน์',
  paper: 'กระดาษ',
  carrierNotSelected: 'ยังไม่ได้เลือกผู้ขนส่ง',
  carrierAlreadyExists: 'มีผู้ขนส่งนี้อยู่แล้ว',
  bookingMethodNotSelected: 'ยังไม่ได้เลือกวิธีการจองพื้นที่',
  shortMessage: 'ข้อความ SMS',
  alreadyDefaultContact: 'มีผู้ติดต่อเริ่มต้นอยู่แล้ว การบันทึกจะใช้ผู้ติดต่อปัจจุบันเป็นค่าเริ่มต้น',
  notSaveTwoDefaultContact: 'ไม่สามารถบันทึกผู้ติดต่อเริ่มต้นสองรายการได้!',
  contactNameAndPhoneNumberCannotBlank: 'ชื่อผู้ติดต่อและเบอร์โทรศัพท์ไม่สามารถเว้นว่างได้!',
  contactNameCannotBlank: 'ชื่อผู้ติดต่อไม่สามารถเว้นว่างได้!',
  emailBlankOrFormatError: 'อีเมลว่างเปล่าหรือรูปแบบไม่ถูกต้อง!',
  mobileBlankOrFormatError: 'เบอร์มือถือว่างเปล่าหรือรูปแบบไม่ถูกต้อง!',
  sameAirlineInvalidMsg: '{0} มี【{1}】ในเส้นทางเดียวกันที่มี【{2}】อยู่แล้ว โปรดอย่าเพิ่มซ้ำ!',
  mailMode: 'รับทางอีเมล',
  phoneMode: 'รับทาง SMS',
  syncContact: 'ซิงค์ข้อมูลไปยังผู้ติดต่อพันธมิตร',
  currentJob: 'ธุรกิจปัจจุบัน',
  mobilePhoneNumberValidNumber: 'เบอร์มือถือต้องเป็นตัวเลขที่ถูกต้องเท่านั้น',
  emailFormatError: 'รูปแบบอีเมลไม่ถูกต้อง',
  emailLengthCannotExceed128Characters: 'ความยาวอีเมลต้องไม่เกิน 128 ตัวอักษร',
  phoneNumberLengthCannotExceed32Characters: 'ความยาวเบอร์มือถือต้องไม่เกิน 32 ตัวอักษร',
  phoneNumberCannotLongerThan32Characters: 'ความยาวเบอร์โทรศัพท์ต้องไม่เกิน 32 ตัวอักษร',
  expenseFinancialDate: 'วันที่ทางการเงินของค่าใช้จ่าย',
  dailySettlement: 'ชำระเป็นรายวัน',
  adjustContractInformationInBasicData: 'บริษัทของคุณได้เปิดใช้งานเมนูจัดการสัญญาแล้ว โปรดปรับปรุงข้อมูลควบคุมเครดิตของสัญญาภายในระยะเวลาที่มีผลใน ข้อมูลพื้นฐาน-การจัดการสัญญา!',
  masterAgent: 'ตัวแทนหลัก',
  secondaryAgent: 'ตัวแทนระดับสอง',
  billAddressCannotEmpty: 'ที่อยู่ใบแจ้งหนี้ไม่สามารถเว้นว่างได้!',
  nmsCannotEmpty: 'ผู้ดูแลระบบไม่สามารถเว้นว่างได้!',
  firstPlease: 'กรุณา',
  selectImportFile: 'เลือกไฟล์ที่จะนำเข้า:',
  fileSizeCannotExceed20m: 'ขนาดไฟล์ต้องไม่เกิน 20M',
  startImport: 'เริ่มนำเข้า',
  emailAddress: 'ที่อยู่อีเมล',
  specificContactEmailAddress: 'ที่อยู่อีเมลผู้ติดต่อเฉพาะ',
  userCannotEmpty: 'ผู้ใช้ไม่สามารถเว้นว่างได้!',
  destinationOperationAgentNotMaintained: 'ยังไม่ได้บำรุงรักษาตัวแทนดำเนินการที่ท่าเรือปลายทาง',
  completeInputItems: 'กรุณากรอกข้อมูลให้ครบถ้วน',
  disassociateAndSaveModifications: 'ยืนยันที่จะยกเลิกการเชื่อมโยงและบันทึกการแก้ไขหรือไม่?',
  alreadyDefaultBankInformation: 'มีข้อมูลธนาคารเริ่มต้นอยู่แล้ว การบันทึกจะใช้ข้อมูลธนาคารปัจจุบันเป็นค่าเริ่มต้น',
  ordinary: 'ทั่วไป',
  supervise: 'กำกับดูแล',
  warehousingRequirements: 'ข้อกำหนดการรับสินค้าเข้าโกดัง',
  alreadyDefaultWarehouse: 'มีโกดังเริ่มต้นอยู่แล้ว การบันทึกจะใช้โกดังปัจจุบันเป็นโกดังเริ่มต้น',
  operateInMasterDataContractManagement: 'บริษัทของคุณได้รับสิทธิ์เมนู【การจัดการสัญญา】แล้ว โปรดดำเนินการในข้อมูลพื้นฐาน-การจัดการสัญญา',
  contract: 'สัญญา',
  effectiveAndExpirationDateCannotBlank: 'บ้าน > ผลิตภัณฑ์ > Wave On The Wave On The Wave On The Wave On The Wave On The Wave On The Wave On The Wave On The Wave On The Wave On The Wave On The Wave On The Wave On The Wave On The Wave On The Wave On The Wave On The Wave On The Wave On The Wave On The Wave On The Wave On The Wave On The Wave On The Wave On The Wave On The Wave',
  fileDeletedSuccessfully: 'ลบไฟล์สำเร็จแล้ว!',
  viewContactInformation: 'ดูข้อมูลติดต่อ',
  lineAlreadyExistsAndCannotAddedRepeatedly: 'เส้นทางนี้มีอยู่แล้ว ไม่สามารถเพิ่มซ้ำได้',
  vendorCannotEmpty: 'Vendor ไม่สามารถเว้นว่างได้!',
  confirmDeleteSupplyChainLine: 'ยืนยันที่จะลบเส้นทางซัพพลายเชนนี้หรือไม่?',
  deleteSupplyChain: 'ลบซัพพลายเชน',
  emailAddress2: 'ที่อยู่อีเมล',
  setDefaultAutoSendMailbox: 'ตั้งเป็นอีเมลส่งอัตโนมัติเริ่มต้น',
  alreadyDefaultInvoicingHeader: 'มีชื่อใบแจ้งหนี้เริ่มต้นอยู่แล้ว การบันทึกจะใช้ชื่อใบแจ้งหนี้ปัจจุบันเป็นค่าเริ่มต้น',
  branchCannotBlank: 'สาขาไม่สามารถเว้นว่างได้',
  cannotRepeat: 'ไม่สามารถซ้ำได้',
  bookingAgentNotSelected: 'ยังไม่ได้เลือกตัวแทนการจอง',
  bookingAgentAlreadyExists: 'ตัวแทนการจองมีอยู่แล้ว',
  defaultMarkupRange: 'อัตราการเพิ่มราคาเริ่มต้น',
  rateClass: 'ระดับอัตราค่าขนส่ง',
  batchSaveSucceeded: 'บันทึกรายการจำนวนมากสำเร็จ',
  priceAdjustmentRecordUsedAndCannotDeleted: 'มีการใช้บันทึกการปรับราคาแล้ว ไม่สามารถลบได้',
  deleteSucceeded: 'ลบสำเร็จ!',
  selectAppointmentNumberToEdit: 'โปรดเลือกหมายเลขสัญญาที่ต้องการแก้ไข!',
  shipSecretaryAppointmentNumberCannotEmpty: 'หมายเลขสัญญาของบริษัทเรือไม่สามารถเว้นว่างได้!',
  innerContractNoCannotEmpty: 'หมายเลขสัญญาภายในไม่สามารถเว้นว่างได้!',
  effectiveDateCannotBlank: 'บ้าน > ผลิตภัณฑ์ > Live in the words > Live in the words',
  expirationDateCannotBlank: 'วันที่หมดอายุไม่สามารถเว้นว่างได้!',
  expirationDateMustGreaterEqualEffectiveDate: 'บ้าน > ผลิตภัณฑ์ > Wonder Wonder Wonder Wonder Wonder Wonder Wonder Wonder Wonder Wonder Wonder Wonder Wonder Wonder Wonder Wonder Wonder Wonder Wonder Wonder Wonder Wonder Wonder Wonder Wonder Wonder Wonders',
  defaultPriceIncreaseRangeCannotBlank: 'อัตราการเพิ่มราคาเริ่มต้นไม่สามารถเว้นว่างได้!',
  selectRouteCorrespondingToDestinationPort: 'โปรดเลือกเส้นทางที่ตรงกับท่าปลายทาง!',
  oneRecordWithoutRouteAndDestination: 'บันทึกที่ไม่มีเส้นทางและท่าปลายทางสามารถมีได้เพียงรายการเดียว!',
  sameRoute: 'เส้นทางเดียวกัน',
  oneRecordCanGeneratedPleaseModify: 'อนุญาตให้สร้างบันทึกได้เพียงรายการเดียว โปรดแก้ไข!',
  sameRouteAndDestination: 'เส้นทางและท่าปลายทางเดียวกัน',
  samePol: 'ท่าเรือต้นทางเดียวกัน',
  associatedRoute: 'เส้นทางที่เกี่ยวข้อง',
  isParentCompany: 'เป็นบริษัทแม่หรือไม่',
  isFba: 'เป็น FBA หรือไม่',
  subsidiaryInformation: 'ข้อมูลบริษัทลูก',
  deleteSubsidiaryTips: 'โปรดเลือกบริษัทลูกที่ต้องการลบ!',
  deleteSubsidiaryConfirm: 'หลังการลบจะยกเลิกความสัมพันธ์ระหว่างบริษัทแม่และบริษัทลูก ต้องการดำเนินการต่อหรือไม่?',
  changeParentCompany: 'มีบริษัทลูกที่เกี่ยวข้องอยู่ โปรดยกเลิกความสัมพันธ์กับบริษัทลูกก่อนดำเนินการ!',
  officeChangeForSubsidiaryCompany: 'มีบริษัทลูกที่เกี่ยวข้องอยู่ หลังการแก้ไขบริษัทลูกอาจไม่สามารถเลือกพันธมิตรนี้ได้เมื่อแก้ไขบริษัทแม่ ต้องการดำเนินการต่อหรือไม่?',
  quota: 'วงเงิน',
  monthlySpecifiedDate: 'วันที่กำหนดรายเดือน',
  weeklySettlement: 'การชำระเงินรายสัปดาห์',
  semilunarKnot: 'การชำระเงินครึ่งเดือน',
  settlementDay: 'การชำระเงินรายวัน',
  statementDate: 'วันที่ออกใบแจ้งหนี้',
  customerSupplierType: 'ประเภทลูกค้า/ผู้ขาย',
  CustomerMailbox: 'อีเมลลูกค้า',
  WhetherToSendMailAutomatically: 'ส่งอีเมลอัตโนมัติหรือไม่',
  DefaultMailSendingObject: 'ผู้รับอีเมลเริ่มต้น',
  DefaultMailSendingObjectTip: 'หากเลือกผู้รับอีเมลแต่ไม่มีที่อยู่อีเมล จะส่งให้ผู้สร้างใบแจ้งหนี้แทน',
  BulkUpdateSurcharge: 'อัปเดตค่าบริการเพิ่มเติมเป็นกลุ่ม',
  autoEmailSettings: 'การตั้งค่าการส่งอีเมลอัตโนมัติ',
  taxControlPlatformSending: 'ส่งผ่านแพลตฟอร์มควบคุมภาษี',
  systemAutomaticSending: 'ระบบส่งอัตโนมัติ',
  systemAutomaticSendingObject: 'ผู้รับที่ระบบส่งอัตโนมัติ',
  taxControlPlatformSendingObject: 'ผู้รับที่ส่งผ่านแพลตฟอร์มควบคุมภาษี',
  partnerInvoiceReminder: 'แพลตฟอร์มควบคุมภาษีและระบบนี้สามารถส่งอีเมลไปยังกล่องจดหมายที่กำหนดแยกกัน หากเปิดใช้งานการส่งอัตโนมัติ แต่ที่อยู่อีเมลของผู้รับที่เลือกไว้ว่างเปล่า จะส่งให้ผู้สร้างใบแจ้งหนี้แทน',
  interestFreeCompany: 'บริษัทปลอดดอกเบี้ย',
  uniformRenewalSurcharge: 'อัปเดตค่าบริการเพิ่มเติมแบบรวมศูนย์',
  lookSurcharge: 'ดูค่าบริการเพิ่มเติม',
  batchReplaceAfterSave: 'คำเตือน: หลังจากบันทึก จะแทนที่ค่าบริการเพิ่มเติมที่ดูแลไว้ก่อนหน้าเป็นกลุ่ม และจะมีผลกับทุกเส้นทางภายใต้ราคาสัญญานี้',
  validityPeriodRepeatedAndCannotCopy: 'วันหมดอายุซ้ำกัน ไม่สามารถคัดลอกได้',
  sameRoutePodPol: 'เส้นทางเดียวกัน ท่าเรือต้นทาง ท่าเรือปลายทาง',
  sameRoutePol: 'เส้นทางเดียวกันและท่าเรือต้นทาง',
  agreementContent: 'พรรค A: บุคคลที่ได้รับมอบหมายการจองห้องโดยสารข้าม Tenant (ต่อไปนี้จะเรียกว่า พรรค)\n' +
    'Party B: ผู้รับการจองข้าม Tenant (ต่อไปนี้จะเรียกว่า Party B)\n' +
    '\n' +
    'A. ทั้งสองฝ่าย B ปฏิบัติตามวัตถุประสงค์ของ "การปรับปรุงประสิทธิภาพลดการเชื่อมโยงส่งเสริมการพัฒนาชี้แจงความรับผิดชอบและควบคุมพฤติกรรม" ตามข้อกำหนดของกฎหมายและข้อบังคับที่เกี่ยวข้องของรัฐและเซี่ยงไฮ้ในการจองห้องพักกับฝ่าย A ในรูปแบบของการจองทางอิเล็กทรอนิกส์ผ่านแพลตฟอร์ม CARGOWARE โดยฝ่าย B เป็นไปตามหลักการของ "ความเท่าเทียมกันและผลประโยชน์ร่วมกันฉันทามติ" บรรลุข้อตกลงดังต่อไปนี้:\n' +
    '\n' +
    'บทที่ 1 ทั่วไป\n' +
    '1. ข้อตกลงนี้เป็นข้อตกลงทั่วไปอย่างเป็นทางการระหว่างฝ่าย A และฝ่าย B เกี่ยวกับธุรกิจส่งออกสินค้าทางทะเลที่เกี่ยวข้องผ่านแพลตฟอร์ม CARGOWARE ในลักษณะการจองทางอิเล็กทรอนิกส์ที่ได้รับมอบหมายจาก Tenant เมื่อคู่สัญญาของ A และ B ได้ทำเครื่องหมายยอมรับในข้อตกลงนี้ที่แพลตฟอร์มของ CARGOWARE ข้ามฟังก์ชันการมอบหมายของ Tenant แพลตฟอร์มของ CARGOWARE จะถือว่าเป็นข้อตกลงที่ผู้ใช้แพลตฟอร์มยอมรับความรับผิดชอบและภาระผูกพันของข้อตกลงนี้แล้ว\n' +
    '2. พรรคต้องจัดตั้งบริษัทหรือธุรกิจที่มีคุณสมบัติเป็นนิติบุคคลอิสระตามกฎหมายที่มีใบอนุญาตประกอบธุรกิจที่ถูกต้องตามกฎหมายและดำเนินธุรกิจตัวแทนขนส่งสินค้าระหว่างประเทศอย่างถูกต้องตามกฎหมายในขอบเขตของการดำเนินงานที่ระบุไว้ในใบอนุญาตประกอบธุรกิจ\n' +
    '3. พรรค B จะต้องจัดตั้ง บริษัท หรือธุรกิจที่มีคุณสมบัติเป็นนิติบุคคลอิสระตามกฎหมายที่มีใบอนุญาตประกอบธุรกิจที่ถูกต้องตามกฎหมายและดำเนินธุรกิจตัวแทนขนส่งสินค้าระหว่างประเทศตามกฎหมายในขอบเขตของการดำเนินงานที่ระบุไว้ในใบอนุญาตประกอบธุรกิจ;\n' +
    '4. ฝ่าย A และ B ได้รับรหัสผู้ใช้แพลตฟอร์มองค์กรและคีย์ (ลายเซ็นข้อมูลอิเล็กทรอนิกส์) อย่างถูกต้องตามกฎหมายหลังจากลงทะเบียนและตรวจสอบผ่านแพลตฟอร์ม CARGOWARE การกระทำใด ๆ ที่ดำเนินการโดยทั้งสองฝ่ายผ่านแพลตฟอร์ม Data CARGOWARE โดยใช้ลายเซ็นข้อมูลอิเล็กทรอนิกส์ถือเป็นการแสดงความหมายที่แท้จริงของทั้งสองฝ่ายและยืนยันและยินดีที่จะรับผิดชอบและความเสี่ยงทั้งหมดที่เกิดขึ้นด้วยตนเอง\n' +
    '5. ฝ่าย A ตกลงที่จะยื่นคำร้องขอจองห้องโดยสารต่อฝ่าย B ในรูปแบบของใบตราส่งสินค้าบนกระดาษทดแทนการจองทางอิเล็กทรอนิกส์ที่ได้รับมอบหมายจากแพลตฟอร์มข้าม Tenant และในรูปของ Tenant ID และ Key\n' +
    '6. ฝ่าย B ยอมรับการมอบหมายของฝ่าย A ด้วยการมอบหมายการตอบกลับทางอิเล็กทรอนิกส์แทนกระดาษและยืนยันการจองในรูปแบบ Tenant ID และ Key ฝ่าย B จะดำเนินการจัดหาเรือบรรทุกสินค้าส่งออกไปยังผู้ให้บริการหรือตัวแทนของผู้ให้บริการตามข้อตกลงทางธุรกิจที่เกี่ยวข้องของทั้งสองฝ่าย ป้อนคลังสินค้า, การบรรจุ, การโหลดเรือและชุดของธุรกิจส่งต่อ;\n' +
    '7. ฝ่าย A และ B ใช้กลไกกระบวนการจองทางอิเล็กทรอนิกส์และวิธีการใช้งานที่ได้รับมอบหมายข้าม Tenant ซึ่งกําหนดล่วงหน้าโดยแพลตฟอร์มคลาวด์ข้อมูล และทั้งฝ่าย A และ B กรอก Tenant ID ของกันและกันในรายการฟังก์ชั่นนี้\n' +
    '8. ทั้ง A และ B มีหน้าที่ในการป้องกันการบุกรุกหรือการส่งผ่านที่ผิดกฎหมายเพื่อให้แน่ใจว่าผู้ปฏิบัติงานที่ส่งและรับนั้นได้รับอนุญาตตามกฎหมายในการปกป้องบันทึกทางธุรกิจและข้อมูลจากการบุกรุกการดัดแปลงหรือการทำลาย\n' +
    '9. ฝ่าย B จะต้องส่งการตอบกลับผ่านแพลตฟอร์มในเวลาที่เหมาะสมหลังจากได้รับเอกสารการสมัครการจองทางอิเล็กทรอนิกส์ที่ได้รับมอบหมายจากฝ่าย A ข้าม Tenant ฝ่าย A ควรใส่ใจกับสถานะของแอปพลิเคชันการมอบหมายการจองทางอิเล็กทรอนิกส์ของตนเองตลอดเวลา หากไม่ได้รับข้อมูลการประมวลผลจากอีกฝ่าย ฝ่าย A มีหน้าที่ติดต่อและหาสาเหตุโดยเร็วที่สุด\n' +
    '10. เมื่อคู่สัญญา A และ B ไม่ได้รับการยืนยันภายในระยะเวลาที่ตกลงกันไว้ ให้ดำเนินการตามขั้นตอนที่สอดคล้องกัน มิฉะนั้นคู่สัญญาจะมีสิทธิ์สันนิษฐานได้ว่าการส่งมอบครั้งแรกได้รับแล้ว และแพลตฟอร์ม CARGOWARE จะไม่รับผิดชอบต่อความทันเวลาและประสิทธิผลของการยอมรับของทั้งสองฝ่าย\n' +
    '11. ข้อมูลการจองทางอิเล็กทรอนิกส์และข้อมูลการตอบกลับที่ได้รับมอบหมายจาก Cross Tenant ซึ่งเป็นไปตามข้อกำหนดของรหัสการดำเนินงานของแพลตฟอร์มของทั้งสองฝ่าย A และ B มีผลทางกฎหมายเทียบเท่ากับเอกสารที่เป็นลายลักษณ์อักษร ฝ่าย A มีสิทธิ์ติดตามค่าขนส่งสำหรับสินค้าที่จัดส่งโดยฝ่าย B\n' +
    'บทที่ 2 ค่าธรรมเนียมและการตั้งถิ่นฐาน\n' +
    'คู่สัญญา A B ดำเนินการผ่านบริการมอบอำนาจทางธุรกิจที่เกี่ยวข้องกับการจองห้องโดยสารอิเล็กทรอนิกส์ผ่าน Tenant ตามข้อกำหนดเฉพาะของข้อตกลงการส่งต่อที่ลงนามโดยทั้งสองฝ่ายและข้อตกลงการชำระค่าใช้จ่ายที่เกี่ยวข้อง\n' +
    'หมวดที่ 3 สิทธิและหน้าที่ของคู่สัญญา\n' +
    '1. ในกรณีที่มีการเก็บรักษาลายเซ็นข้อมูลอิเล็กทรอนิกส์ที่แพลตฟอร์มของคาร์โกแวร์จัดเตรียมไว้ให้ไม่ดีอันเนื่องมาจากเหตุผลของฝ่าย A หรือการดำเนินการที่ไม่ได้รับอนุญาตอันเนื่องมาจากการใช้งานของผู้อื่นหรือการใช้งานและการดำเนินการข้อมูลที่ผิดกฎหมาย ฝ่าย A จะเป็นผู้รับผลที่ตามมา\n' +
    '2. เนื้อหาที่ A ส่งข้อมูลไปยังฝ่าย B หรือป้อนข้อมูลออนไลน์ในระบบอิเล็กทรอนิกส์ของ A จะรวมถึงแต่ไม่จำกัดเพียงกำหนดเวลาที่ถูกต้องล่วงหน้าหรือเที่ยวบินของเครื่องบิน ชื่อผู้ให้บริการ หมายเลขการขนส่ง หมายเลขใบตราส่ง หมายเลขข้อตกลง ท่าเรือปลายทาง ท่าเรือแห่งการขนถ่าย รายละเอียดของสินค้า (ชื่อสินค้า จำนวนชิ้น น้ำหนักรวม ปริมาตร คำอธิบายคุณสมบัติของสินค้า ขนาดของสินค้าพิเศษ ฯลฯ ) เงื่อนไขการขนส่งสินค้า ปริมาณกล่องชนิดบรรจุล่วงหน้า ผู้ส่ง ผู้รับ ผู้แจ้ง เครื่องหมายการจัดส่ง และข้อมูลอื่น ๆ ที่จำเป็นต้องระบุเป็นพิเศษและส่งไปตามเนื้อหาที่ตกลงกันโดยทั้งสองฝ่าย\n' +
    '3. สำหรับสินค้าพิเศษที่ได้รับมอบหมายจากฝ่าย A ให้จัดส่งในห้องโดยสารเช่นสินค้าอันตรายสินค้าแช่เย็นสินค้าขนาดพิเศษสินค้าต้องตรวจสอบกล่องหรือต้องใช้กล่องพิเศษเพื่อดำเนินการและสินค้าพิเศษอื่น ๆ ที่ต้องมีหนังสือยืนยันเป็นลายลักษณ์อักษรจากฝ่าย A เพื่อยอมรับการจองเช่นข้อมูลภาพวาดของสินค้าขนาดใหญ่และหลักฐานการทำความเย็นล่วงหน้าของกล่องเย็น ฯลฯ สำหรับสินค้าอันตรายยังต้องให้กระดาษประกาศสินค้าอันตรายและใบรับรองการบรรจุสินค้าอันตรายและเอกสารของผู้ให้บริการอื่น ๆ ที่จำเป็น ฯลฯ สำหรับสินค้าบางอย่างที่ต้องจ่ายเงินก่อนแล้วจึงจองห้องโดยสารควรจ่ายให้กับฝ่าย B ในเวลาที่เหมาะสมก่อนที่จะยอมรับการจองห้องพัก\n' +
    '4. ข้อมูลที่แท้จริงของฝ่าย A เกี่ยวกับสินค้าที่จัดส่งจะต้องประกาศตามความเป็นจริงในรายงานการจองทางอิเล็กทรอนิกส์ หากฝ่าย A สำแดงเท็จก่อให้เกิดความเสียหายต่อผลประโยชน์ของฝ่าย B หรือบุคคลที่สาม ฝ่าย A จะต้องรับผิดชอบต่อความเสียหายที่เกี่ยวข้อง\n' +
    '5. พรรค A จะต้องแจ้งให้พรรค B ในวันที่สินค้าถูกโหลดลงในภาชนะหรือร้านขายของชำเข้าไปในกอง (ห้องสมุด) ในกรณีที่มีการเปลี่ยนแปลงข้อมูลการมอบหมายการจอง; พรรค A จะยื่นขอการเปลี่ยนแปลงจากฝ่าย B เป็นลายลักษณ์อักษรหรือในรูปแบบอื่น ๆ ที่ตกลงกันโดยทั้งสองฝ่าย\n' +
    '6. ฝ่าย A มีภาระผูกพันที่จะต้องชำระค่าขนส่ง ค่าธรรมเนียมเพิ่มเติมและค่าใช้จ่ายอื่น ๆ สำหรับสินค้าที่ได้รับมอบหมายให้ฝ่าย B ดำเนินการผ่านการจองทางอิเล็กทรอนิกส์ตามเวลาที่ตกลงกันไว้\n' +
    '7. พรรค A จะต้องผ่านพิธีการศุลกากรเป็นลายลักษณ์อักษรหรือรูปแบบอื่น ๆ ที่ตกลงกันไว้โดยทั้งสองฝ่ายหากจำเป็นต้องถอนใบนำส่งสินค้าที่สั่งซื้อมิฉะนั้นพรรค B จะต้องรับผิดชอบต่อค่าใช้จ่ายใด ๆ ที่เกิดขึ้นทั้งหมด\n' +
    '8. การจองทางอิเล็กทรอนิกส์ที่ได้รับมอบหมายจากฝ่าย B จากฝ่าย A จะต้องยืนยันการยอมรับหรือปฏิเสธการมอบหมายการจองทางอิเล็กทรอนิกส์จากฝ่าย B ในเวลาที่เหมาะสมในรูปแบบของข้อมูลอิเล็กทรอนิกส์\n' +
    '9. ทั้งสองฝ่ายจะต้องใช้วิธีการจองห้องพักแบบดั้งเดิมเพื่อดำเนินธุรกิจการจองห้องพักและการส่งข้อมูลในช่วงเวลาดังกล่าวเนื่องจากความล้มเหลวที่ผิดปกติของเครือข่ายของตนเอง เครือข่ายสาธารณะ หรือแพลตฟอร์ม CARGOWARE\n' +
    'บทที่ 4 การยืนยันการจองห้องโดยสารอิเล็กทรอนิกส์\n' +
    '1. ฝ่าย B จะต้องดำเนินการในเวลาที่เหมาะสมหลังจากได้รับรายงานข้อมูลการจองทางอิเล็กทรอนิกส์จากฝ่าย A และจะส่งการตอบกลับเพื่อยืนยันการยอมรับการมอบหมายหรือการปฏิเสธตามคำขอของแพลตฟอร์ม การปฏิเสธจะระบุเหตุผลในการปฏิเสธ\n' +
    '2. ฝ่าย A จะถือว่าฝ่าย B ยอมรับการจองห้องพักของฝ่าย A ก็ต่อเมื่อฝ่าย B ส่งคืนผลตอบแทนยืนยันการยอมรับมอบหมาย\n' +
    '3. หากฝ่าย A ได้ดำเนินกิจกรรมต่างๆ ก่อนที่ฝ่าย B จะไม่ได้รับการยืนยัน ซึ่งสามารถกระทำได้หลังจากที่ฝ่าย B ยอมรับการจองห้องพักของฝ่าย A แล้ว การกระทำดังกล่าวถือเป็นการละเมิดและความรับผิดทางกฎหมายและความเสี่ยงที่เกิดขึ้นจะเป็นของฝ่าย A\n' +
    '4. ฝ่าย B จะยอมรับการฝากขังที่จองไว้โดยฝ่าย A และดำเนินธุรกิจการขนส่งที่เกี่ยวข้องเพื่อการส่งออกในนามของผู้ให้บริการตามเนื้อหาและความต้องการที่ได้รับการยืนยัน และไม่มีการกระทำใด ๆ ของฝ่าย B ภายใต้ข้อตกลงนี้จะถือเป็นสัญญาหรือการรับประกันว่าใบตราส่งสินค้าจะสามารถทำการจองได้สำเร็จ\n' +
    'บทที่ 5 การปฏิบัติตามข้อตกลง\n' +
    '1. คู่สัญญา A และ B จะต้องปฏิบัติตามเนื้อหาที่เกี่ยวข้องตามข้อตกลงและเงื่อนไขนี้อย่างเคร่งครัด\n' +
    '2. คู่สัญญาต้องไม่โอนผลประโยชน์ตามสัญญานี้ให้กับบุคคลหรือองค์กรอื่นที่ไม่เกี่ยวข้อง\n' +
    '3. คู่สัญญาใด ๆ ในข้อตกลงในการปฏิบัติตามภาระผูกพันที่กำหนดไว้ในข้อตกลงนี้ไม่สามารถปฏิบัติตามหรือไม่สามารถปฏิบัติตามเรื่องที่เกี่ยวข้องกับข้อตกลงได้ทันเวลาเนื่องจากเหตุสุดวิสัย คู่สัญญาจะต้องแจ้งให้คู่สัญญาทราบทันทีและพยายามใช้วิธีอื่น ๆ คู่สัญญาของข้อตกลงที่มีความล่าช้าการรั่วไหลหรือความผิดพลาดในการรายงานข้อมูลในช่วงเวลานี้จะไม่รับผิดชอบต่อผลที่ไม่พึงประสงค์ที่เกิดจากเวลาข้างต้น\n' +
    '4. คู่สัญญาทั้งสองฝ่ายจะต้องแจ้งให้คู่สัญญาและบุคคลอื่นที่เกี่ยวข้องทราบทันทีหากพบว่ามีการละเมิดความปลอดภัยการใช้ที่ผิดกฎหมายหรือการกระทำที่ผิดกฎหมาย ในระหว่างนี้ให้ระงับข้อมูลอิเล็กทรอนิกส์เป็นการชั่วคราวจนกว่าสถานการณ์ความปลอดภัยจะกลับสู่สภาวะปกติ\n' +
    '5. เมื่อคู่สัญญาของ A B ลงนามในหนังสือสัญญาตัวแทนขนส่งสินค้า ข้อตกลงนี้ทำหน้าที่เป็นภาคผนวกของข้อตกลงนี้ และข้อตกลงนี้ยังไม่ครบถ้วนตามข้อกำหนดที่เกี่ยวข้องของหนังสือสัญญาตัวแทนขนส่งสินค้า\n' +
    'บทที่ 6 การเปลี่ยนแปลงและการสิ้นสุดข้อตกลง\n' +
    '1. คู่สัญญาฝ่ายใดฝ่ายหนึ่งในข้อตกลงนี้ไม่สามารถเปลี่ยนแปลงและยกเลิกข้อตกลงโดยไม่ได้รับอนุญาต ในกรณีที่มีเหตุผลพิเศษที่ไม่สามารถดำเนินการต่อได้หรือจำเป็นต้องเปลี่ยนแปลงต้องได้รับความยินยอมจากคู่สัญญาอีกฝ่ายหนึ่งและดำเนินการเปลี่ยนแปลงหรือยกเลิกข้อตกลงภายในระยะเวลาที่กำหนดไว้ในข้อตกลง หากเสนอเกินระยะเวลาที่กำหนดไว้ในข้อตกลงต้องแบกรับความเสียหายที่เกิดขึ้นจริงที่อีกฝ่ายได้ก่อขึ้น\n' +
    '2. เมื่อคู่สัญญาบรรลุข้อตกลงในการยกเลิกข้อตกลงนี้ คู่สัญญาทั้งสองฝ่ายจะต้องลบรายการที่ได้รับความยินยอมที่เกี่ยวข้องและล้างข้อมูลการกำหนดค่าที่เกี่ยวข้องข้ามรายการฟังก์ชันการมอบหมายของ Tenant บนแพลตฟอร์ม CARGOWARE\n' +
    'บทที่ VII ความรับผิดสำหรับการละเมิด\n' +
    'การฝ่าฝืนข้อตกลงของคู่สัญญาจะต้องชดเชยตามความเสียหายที่เกิดขึ้นจริงจากการกระทำนี้ให้กับคู่สัญญา\n' +
    'บทที่ 8 อื่นๆ\n' +
    'ข้อพิพาทใด ๆ ที่เกิดขึ้นจากข้อตกลงนี้ทั้งสองฝ่ายจะต้องเจรจาหาข้อยุติก่อนภายใต้หลักการของผลประโยชน์ร่วมกันและไม่สามารถเจรจาได้จะถูกฟ้องร้องต่อศาลทางทะเลในท้องถิ่นที่ทั้งสองฝ่ายจดทะเบียนเพื่อดำเนินการ',
  SuccessSyncCloudAndStarrySky: 'ซิงโครไนซ์เมฆดาวประสบความสำเร็จ',
  FailSyncCloudAndStarrySky: 'ซิงค์คลาวด์สตาร์ล้มเหลว {0}',
  HMSyncYongYouSuccess: 'การประสานข้อมูลลูกค้าเพื่อนประสบความสำเร็จ msg"{0}"',
  HMSyncYongYouFail: 'ล้มเหลวในการซิงค์ข้อมูลลูกค้า {0}',
  HMSyncYongYouSuccess2: 'การประสานข้อมูลผู้ขายสำเร็จแล้ว msg"{0}"',
  HMSyncYongYouFail2: 'ล้มเหลวในการซิงค์ข้อมูลผู้ขาย {0}',
  bankEnglishName: 'ชื่อธนาคาร (ภาษาอังกฤษ)',
  bankAddress: 'ที่อยู่ธนาคาร',
  bankEnglishAddress: 'ที่อยู่ธนาคาร (ภาษาอังกฤษ)',
  EidtBranchNotSameTip: 'โปรดดำเนินการแก้ไขเมื่อสลับสาขามุมขวาบนเข้ากับ บริษัท ในเครือของพันธมิตร',
  BranchNoPartnerPermission: 'สาขาปัจจุบันไม่มีสิทธิ์แก้ไขพันธมิตร!',
  DeleteBranchNotSameTip: 'โปรดดำเนินการลบเมื่อสลับสาขามุมขวาบนไปยังบริษัทของพันธมิตร',
  operateBranchNotSameTip: 'ไม่มีสิทธิ์ดำเนินการในขณะนี้โปรดเปลี่ยนสาขามุมขวาบนไปยังบริษัทคู่ค้าที่สอดคล้องกันก่อนที่จะดำเนินการ',
  BranchNoDeletePartnerPermission: 'สาขาปัจจุบันไม่มีสิทธิ์ลบพันธมิตร!',
  MergeBranchNotSameTip: 'โปรดดำเนินการควบรวมกิจการเมื่อสลับสาขามุมขวาบนไปยังบริษัทในเครือของพันธมิตร',
  BranchNoMergePartnerPermission: 'สาขาปัจจุบันไม่มีสิทธิ์ในการรวมพันธมิตร!',
  UnifiedSign: 'ไม่ว่าจะเป็นการลงนามร่วมกัน',
  IfRisk: 'ผู้ค้าที่มีความเสี่ยง',
  customerCode: 'รหัสลูกค้า',
  supplierCode: 'การเข้ารหัสผู้ขาย',
  customerCodeNotSupportChinese: 'รหัสลูกค้าไม่สามารถป้อนภาษาจีนได้',
  supplierCodeNotSupportChinese: 'รหัสผู้ขายไม่สามารถป้อนภาษาจีนได้',
  customersAndSuppliersMustChooseOne: 'ลูกค้าและซัพพลายเออร์จะต้องเลือกอย่างใดอย่างหนึ่ง',
  CustomerCodeNotEmpty: 'รหัสลูกค้าไม่อนุญาตให้ว่างเปล่า',
  SupplierCodeNotEmpty: 'การเข้ารหัสผู้ขายไม่อนุญาตให้ว่างเปล่า',
  CustomerCodeCheck: 'รูปแบบการเข้ารหัสลูกค้ารุ่นใหม่ไม่ถูกต้องโปรดป้อน 【13 หลัก】',
  SupplierCodeCheck: 'รูปแบบการเข้ารหัสของซัพพลายเออร์รุ่นใหม่ไม่ถูกต้องโปรดป้อน 【ABCD ทุกตัวอักษร + ตัวเลข 7 หลัก】',
  CcGroup: 'กลุ่มสำเนา',
  CcAddress: 'ที่อยู่สำเนา',
  ccAgentOverseaOp: 'สำเนา-ต่างชาติ',
  UseEmailGroup: 'ใช้กลุ่มอีเมล',
  PartnersApprovedTips: 'ข้อมูลที่เลือกมีรายการที่ผ่านการตรวจสอบแล้วไม่สามารถแก้ไขได้ กรุณายกเลิกการเลือกก่อนดำเนินการต่อ',
  isInternalCorrespondent: 'เป็นบริษัทในเครือหรือไม่',
  internalCorrespondent: 'บริษัทในเครือ',
  batchAddServer: 'เพิ่มพนักงานบริการเป็นกลุ่ม',
  batchAddServerNoSelected: 'กรุณาเลือกพาร์ทเนอร์ที่ต้องการเพิ่มพนักงานบริการ',
  batchAddServerConfigError: 'พาร์ทเนอร์ที่คุณเลือกไม่รองรับการบำรุงรักษาพนักงานบริการ',
  addServicePersonnel: 'เพิ่มพนักงานบริการ',
  BookingAgentLevel: 'ระดับตัวแทนการจอง',
  bookingAgentLevelNotSelected: 'ยังไม่ได้เลือกระดับตัวแทนการจอง',
  Underestimation: 'คำนวณหนี้',
  IfAdvancePayment: 'เงินมัดจำ',
  CreditRemarks: 'คำอธิบายเพิ่มเติมเกี่ยวกับบัญชีเครดิต',
  DefaultSettlementForInsurance: 'ผู้รับผิดชอบการชำระเงินประกันตามค่าเริ่มต้น',
  DriverInformation: 'ข้อมูลคนขับ',
  DriverName: 'ชื่อคนขับ',
  DriverPhoneNumber: 'เบอร์โทรคนขับ',
  PlateNumber: 'ป้ายทะเบียนรถ',
  IdentityCard: 'เลขบัตรประชาชน',
  DriverNameRequired: 'ต้องระบุชื่อคนขับ',
  CreditUnit: 'หน่วยวงเงิน',
  creditDateUnit: 'หน่วยงวดบัญชี',
  b2bDisplay: 'แสดงใน B2B หรือไม่'
}
